






import { Component, Mixins } from "vue-property-decorator";
import { Department } from "../../../../domain/department";

@Component({
  components: {
  }
})
export default class DepartmentEditor extends Mixins() {
  clear(): void {
    this.setDepartment(null);
  }

  private setDepartment(department: Department): void {
    // store内でSessionStorageもセットされる
    this.$store.commit("setDepartment", department);
  }
}
